import { gql } from '@apollo/client';

export function updateMarineHull() {
  return gql`
    mutation modifyMarineHullDetails(
      $entityId: String!
      $policyMarineHullInput: Production_PolicyMarineHullInputs!
    ) {
      production {
        entities {
          policy {
            production {
              modifyMarineHullDetails(
                entityId: $entityId
                policyMarineHullInput: $policyMarineHullInput
              )
            }
          }
        }
      }
    }
  `;
}
